const config = {
  SID_GW_BASE_URL: process.env.REACT_APP_SID_GW_BASE_URL || "null-ref",
  SID_ASSET_DETAILS_GW_BASE_URL:
    process.env.REACT_APP_SID_ASSET_DETAILS_GW_BASE_URL || "null-ref",
  AUTH_GW_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL || "null-ref",
  AUTH_LOGIN_URL:
    (process.env.REACT_APP_AUTH_BASE_URL || "null-ref") + "/login",
  AUTH_REGISTER_URL:
    (process.env.REACT_APP_AUTH_BASE_URL || "null-ref") + "/register",
  DLT_LEARN_MORE_URL: process.env.REACT_APP_DLT_LEARN_MORE_URL || "null-ref",
  DLT_CONTACT_SUPPORT_URL:
    process.env.REACT_APP_DLT_CONTACT_SUPPORT_URL || "null-ref",
  SFS_PORTAL_URL: process.env.REACT_APP_SFS_PORTAL_URL || "null-ref",

  FEATURE_FLAGS: {
    ENTITY_INFORMATION_EDIT_ENABLED:
      process.env.REACT_APP_ENTITY_INFORMATION_EDIT_ENABLED,
    PROFILE_DOCUMENT_CENTER_TAB_ENABLED:
      process.env.REACT_APP_PROFILE_DOCUMENT_CENTER_TAB_ENABLED === "true",
    PORTFOLIO_SFS_ASSETS_TAB_ENABLED:
      process.env.REACT_APP_PORTFOLIO_SFS_ASSETS_TAB_ENABLED === "true",
    DIVIDEND_PAYOUT_METHOD_ENABLED:
      process.env.REACT_APP_DIVIDEND_PAYOUT_METHOD_ENABLED === "true",
  },
} as const;

export default config;
